import { AxiosResponse } from 'axios'
import {
  FileExchangeSourceEnum,
  FileExchangeStatus,
  FileExchangeTypeEnum,
  FileShareRequestBody,
} from '../types/FileShareEnums'
import { apiPaths } from 'configs/apiConfigs'
import { httpClaims } from 'utils/http'
import { fileShareAPI } from '../constants'

export const getFileList = async (
  source: FileExchangeSourceEnum,
  type: FileExchangeTypeEnum,
  status: FileExchangeStatus,
) => {
  const query = `${fileShareAPI.list}?ExchangeTypeList=${type}&StatusList=${status}`
  const data = await httpClaims.get(apiPaths.fileShare(query))
  return data
}

export const fileShareFileUpload = async (data: FileShareRequestBody): Promise<AxiosResponse> => {
  const { File, ExchangeSource, ExchangeType, Comments } = data
  const formData = new FormData()
  formData.append('File', File)
  formData.append('ExchangeSource', ExchangeSource.toString())
  formData.append('ExchangeType', ExchangeType.toString())
  formData.append('Comments', Comments ? Comments : '')

  return httpClaims.post(apiPaths.fileShare(fileShareAPI.upload), formData, {
    headers: { 'Content-Type': 'multipart/form-data', Accept: 'text/plain' },
  })
}

export const fileShareDownloadFile = async (fileId: string): Promise<any> => {
  const query = `${fileShareAPI.download}?FileExchangeId=${fileId}`
  const data = await httpClaims.get(apiPaths.fileShare(query), {
    headers: { accept: 'text/csv' },
    responseType: 'blob',
  })
  return data
}

export const fileShareDeleteFile = async (fileId: string): Promise<any> => {
  const query = `${fileShareAPI.delete}?FileExchangeId=${fileId}`
  const data = await httpClaims.delete(apiPaths.fileShare(query), {
    headers: { accept: 'text/csv' },
    responseType: 'blob',
  })
  return data
}
